import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { RqdEvidenceAPI } from "../api";
import {
  AmlDocumentCategory,
  RqdEvidenceTypeWithDocCategories,
} from "../api/transformers/requiredEvidence";

// Hook API is similar to the old store shape but powered by React Query.
const useRequiredEvidenceTypesStore = (personId: string) => {
  const {
    data = [],
    isLoading: loading,
    error,
  } = useQuery<RqdEvidenceTypeWithDocCategories[], unknown>({
    queryKey: ["requiredEvidenceTypes", personId],
    queryFn: () => RqdEvidenceAPI.getEvidenceTypes(personId),
    enabled: !!personId,
  });

  const helpers = useMemo(
    () => ({
      /**
       * Find evidence request type by type code.
       */
      getType: (code: string) =>
        data.find((el) => el.code === code),

      /**
       * Find selectable aml document categories of certain evidence request type.
       */
      getAmlCategoriesOfType: (code: string): AmlDocumentCategory[] =>
        data.find((el) => el.code === code)?.documentCategories || [],

      /**
       * Find aml document category information.
       */
      getAmlCategory: (categoryCode: string): AmlDocumentCategory | undefined =>
        data
          .flatMap((el) => el.documentCategories || [])
          .find((el) => el.code === categoryCode),
    }),
    [data]
  );

  return {
    data,
    loading,
    error,
    ...helpers,
  };
};

export default useRequiredEvidenceTypesStore;
